import React from 'react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { PlusCircle } from 'lucide-react';
import { Info } from 'lucide-react';
import ProjectCard from '../ProjectCard/ProjectCard';
export var ProjectListSection = function(param) {
    var title = param.title, activeTab = param.activeTab, draftCount = param.draftCount, projects = param.projects, drafts = param.drafts, onChangeTab = param.onChangeTab, onNewProject = param.onNewProject, onEdit = param.onEdit, onView = param.onView, onContinue = param.onContinue, onPublish = param.onPublish, onUpload = param.onUpload, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    return /*#__PURE__*/ React.createElement("div", {
        className: "mt-8 ".concat(className)
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "text-xl font-bold mb-4"
    }, title), /*#__PURE__*/ React.createElement("div", {
        className: "flex border-b border-gray-200 dark:border-gray-800"
    }, /*#__PURE__*/ React.createElement("button", {
        className: "px-4 py-2 font-medium text-sm ".concat(activeTab === 'published' ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'),
        onClick: function() {
            return onChangeTab('published');
        }
    }, "공개된 프로젝트"), /*#__PURE__*/ React.createElement("button", {
        className: "px-4 py-2 font-medium text-sm ".concat(activeTab === 'drafts' ? 'text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 dark:border-blue-400' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'),
        onClick: function() {
            return onChangeTab('drafts');
        }
    }, "임시 저장 (", draftCount, ")")), /*#__PURE__*/ React.createElement("div", {
        className: "mt-4"
    }, activeTab === 'published' ? /*#__PURE__*/ React.createElement(React.Fragment, null, projects.length > 0 ? /*#__PURE__*/ React.createElement("div", {
        className: "space-y-4"
    }, projects.map(function(project) {
        return /*#__PURE__*/ React.createElement(ProjectCard, {
            key: project.id,
            project: project,
            variant: "default",
            onEdit: function() {
                return onEdit && onEdit(project.id);
            },
            onView: function() {
                return onView && onView(project.id);
            }
        });
    }), /*#__PURE__*/ React.createElement("div", {
        className: "border border-dashed border-gray-300 dark:border-gray-700 rounded-lg flex flex-col items-center justify-center p-6 hover:bg-gray-50 dark:hover:bg-gray-900 cursor-pointer transition-colors",
        onClick: onNewProject
    }, /*#__PURE__*/ React.createElement(PlusCircle, {
        className: "h-10 w-10 text-gray-400 mb-2"
    }), /*#__PURE__*/ React.createElement("p", {
        className: "text-gray-500 dark:text-gray-400 font-medium"
    }, "새 프로젝트 만들기"))) : /*#__PURE__*/ React.createElement("div", {
        className: "text-center py-12 bg-gray-50 dark:bg-gray-900 rounded-lg"
    }, /*#__PURE__*/ React.createElement(Info, {
        className: "h-12 w-12 text-gray-400 mx-auto mb-4"
    }), /*#__PURE__*/ React.createElement("h3", {
        className: "text-lg font-medium mb-2"
    }, "아직 공개된 프로젝트가 없습니다"), /*#__PURE__*/ React.createElement("p", {
        className: "text-gray-500 dark:text-gray-400 mb-6"
    }, "첫 번째 프로젝트를 업로드하고 사람들과 공유해보세요!"), /*#__PURE__*/ React.createElement("button", {
        className: "bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full inline-flex items-center transition-colors",
        onClick: onUpload
    }, /*#__PURE__*/ React.createElement(PlusCircle, {
        className: "h-5 w-5 mr-2"
    }), /*#__PURE__*/ React.createElement("span", null, "프로젝트 업로드")))) : /*#__PURE__*/ React.createElement(React.Fragment, null, drafts.length > 0 ? /*#__PURE__*/ React.createElement("div", {
        className: "space-y-4"
    }, drafts.map(function(draft) {
        return /*#__PURE__*/ React.createElement(ProjectCard, {
            key: draft.id,
            project: draft,
            variant: "default",
            onContinue: function() {
                return onContinue && onContinue(draft.id);
            },
            onPublish: function() {
                return onPublish && onPublish(draft.id);
            }
        });
    })) : /*#__PURE__*/ React.createElement("div", {
        className: "text-center py-8 bg-gray-50 dark:bg-gray-900 rounded-lg"
    }, /*#__PURE__*/ React.createElement(Info, {
        className: "h-10 w-10 text-gray-400 mx-auto mb-3"
    }), /*#__PURE__*/ React.createElement("p", {
        className: "text-gray-500 dark:text-gray-400"
    }, "임시 저장된 프로젝트가 없습니다.")))));
};
export default ProjectListSection;
